import { render, staticRenderFns } from "./OrdersConfig.vue?vue&type=template&id=3b82f77c&scoped=true&"
import script from "./OrdersConfig.vue?vue&type=script&lang=js&"
export * from "./OrdersConfig.vue?vue&type=script&lang=js&"
import style0 from "./OrdersConfig.vue?vue&type=style&index=0&id=3b82f77c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82f77c",
  null
  
)

export default component.exports